import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-16c43937"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "domain-category-picker" }
const _hoisted_2 = {
  class: "domain-selection-field__inner cm-align-center el-card",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_3 = {
  key: 0,
  class: "cm-ui-pl10 cm-ui-pr10 gap-x-5",
  style: {"max-height":"200px","overflow-y":"auto"}
}
const _hoisted_4 = { class: "cm-align-center" }
const _hoisted_5 = { class: "domain-selection-field__count" }
const _hoisted_6 = { class: "domain-selection-field__custom-tip" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding":"0 4px","color":"var(--cm-color-text-secondary)"} }, "|", -1))
const _hoisted_8 = { class: "two-pane" }
const _hoisted_9 = { class: "pane pane--left" }
const _hoisted_10 = { class: "pane-body pane-body--scroll" }
const _hoisted_11 = { class: "cat-label" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "cat-label" }
const _hoisted_14 = { class: "cat-chevron" }
const _hoisted_15 = { class: "pane pane--right" }
const _hoisted_16 = { class: "pane-body pane-body--scroll" }
const _hoisted_17 = { class: "site-text" }
const _hoisted_18 = {
  key: 1,
  class: "pane-empty"
}

import {
  buildAllKnownDomainsSet,
  domainCategoryWebsiteData,
  getDomainCategoryById,
  getDomainsForCategoryId,
  toLibraryWildcardDomain,
  DomainSiteItem,
} from '../index'
import { computed, nextTick, onUnmounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'domain-category-picker',
  props: {
    form: {},
    libraryUrls: {},
    extraManualDomains: { default: () => [] },
    disabled: { type: Boolean },
    afterChange: {}
  },
  emits: ["update:libraryUrls", "toggleCustomDomains", "batchImport"],
  setup(__props: any, { emit: __emit }) {

const { t, locale } = useI18n()

function domainCategoryLabel(categoryI18nKey: string) {
  void locale.value
  return t(`accessRestriction.domainCategory.${categoryI18nKey}`)
}

/** 多实例时用于唯一定位 teleport 后的 popper 节点 */
const popperUid = `dcpp-${Math.random().toString(36).slice(2, 11)}`
const popperClassNames = `domain-category-picker__popper ${popperUid}`

const props = __props

const emit = __emit
/** 静态库 domain -> 展示用 title（无则退回域名本身） */
const domainToTitleMap = (() => {
  const m = new Map<string, string>()
  for (const b of domainCategoryWebsiteData) {
    for (const s of b.sites) {
      const d = String(s.domain).trim()
      if (!d) continue
      const key = toLibraryWildcardDomain(d)
      if (!m.has(key)) m.set(key, String(s.title).trim() || key)
    }
  }
  return m
})()
function titleForLibraryDomain(domain: string): string {
  const d = String(domain).trim()
  return domainToTitleMap.get(d) ?? d
}
function setLibraryUrls(next: string[]) {
  emit('update:libraryUrls', next)
}
function removeLibraryDomain(domain: string) {
  toggleDomain(domain, false)
}
const referenceRef = ref<HTMLElement | null>(null)
const searchInputRef = ref<{ focus?: () => void } | null>(null)
const panelVisible = ref(false)
const searchKeyword = ref('')
const activeCategoryId = ref(1)

function getPopperEl(): HTMLElement | null {
  return document.querySelector(`.${popperUid}`) as HTMLElement | null
}

function isInsidePickerUi(target: EventTarget | null): boolean {
  if (!(target instanceof Node)) return false
  const refEl = referenceRef.value
  const popperEl = getPopperEl()
  if (refEl?.contains(target)) return true
  if (popperEl?.contains(target as Node)) return true
  // 面板内若使用 Select，下拉挂在 body
  const el = target as HTMLElement
  if (el.closest?.('.el-select-dropdown')) return true
  return false
}

function closePanel() {
  panelVisible.value = false
  searchKeyword.value = ''
}

function openPanel() {
  if (props.disabled) return
  panelVisible.value = true
}

function onSearchFocus() {
  if (props.disabled) return
  panelVisible.value = true
}

function focusSearchInput() {
  if (props.disabled) return
  panelVisible.value = true
  nextTick(() => {
    searchInputRef.value?.focus?.()
  })
}

function onCustomDomainClick() {
  if (props.disabled) return
  closePanel()
  nextTick(() => emit('toggleCustomDomains'))
}

function onBatchImportClick() {
  if (props.disabled) return
  closePanel()
  nextTick(() => emit('batchImport'))
}

function handleOutsidePointerDown(ev: MouseEvent) {
  if (!panelVisible.value) return
  const target = ev.target
  if (isInsidePickerUi(target)) return
  closePanel()
}

/** 焦点移到 reference 与 popper 之外时收起（与点击外部一致） */
function handleDocumentFocusIn(ev: FocusEvent) {
  if (!panelVisible.value) return
  const target = ev.target
  if (isInsidePickerUi(target)) return
  closePanel()
}

watch(panelVisible, (visible) => {
  document.removeEventListener('mousedown', handleOutsidePointerDown, true)
  document.removeEventListener('focusin', handleDocumentFocusIn, true)
  if (!visible) return
  nextTick(() => {
    if (!panelVisible.value) return
    document.addEventListener('mousedown', handleOutsidePointerDown, true)
    document.addEventListener('focusin', handleDocumentFocusIn, true)
  })
})

onUnmounted(() => {
  document.removeEventListener('mousedown', handleOutsidePointerDown, true)
  document.removeEventListener('focusin', handleDocumentFocusIn, true)
})

const urlSet = computed(() => {
  const s = new Set(props.libraryUrls.map((u) => String(u).trim()).filter(Boolean))
  for (const u of props.extraManualDomains || []) {
    const x = String(u).trim()
    if (x) s.add(x)
  }
  return s
})

/** 分类库 + 手写补充域名合并后的目标域名数量 */
const totalSelectedCount = computed(() => urlSet.value.size)

function dedupeSites(sites: DomainSiteItem[]): DomainSiteItem[] {
  const m = new Map<string, DomainSiteItem>()
  for (const s of sites) {
    const d = String(s.domain).trim()
    if (d && !m.has(d)) m.set(d, { title: s.title, domain: d })
  }
  return [...m.values()]
}

const baseRightSites = computed(() => {
  if (activeCategoryId.value === 0) {
    return dedupeSites(domainCategoryWebsiteData.flatMap((b) => b.sites))
  }
  const b = getDomainCategoryById(activeCategoryId.value)
  return b?.sites?.length ? dedupeSites(b.sites) : []
})

const filteredRightSites = computed(() => {
  const kw = searchKeyword.value.trim().toLowerCase()
  if (!kw) return baseRightSites.value
  return baseRightSites.value.filter(
    (s) =>
      String(s.title).toLowerCase().includes(kw) || String(s.domain).toLowerCase().includes(kw),
  )
})

function isCategoryFull(categoryId: number): boolean {
  const doms = getDomainsForCategoryId(categoryId)
  if (!doms.length) return false
  return doms.every((d) => urlSet.value.has(d))
}

function isCategoryPartial(categoryId: number): boolean {
  const doms = getDomainsForCategoryId(categoryId)
  if (!doms.length) return false
  const some = doms.some((d) => urlSet.value.has(d))
  return some && !isCategoryFull(categoryId)
}

function recomputeCategoryIds() {
  const set = urlSet.value
  const ids: number[] = []
  domainCategoryWebsiteData.forEach((_, i) => {
    const id = i + 1
    const doms = getDomainsForCategoryId(id)
    if (doms.length && doms.every((d) => set.has(d))) ids.push(id)
  })
  props.form.category_ids = ids
}

const knownDomainsSet = buildAllKnownDomainsSet()

const allLibrarySelected = computed(() => {
  for (const d of knownDomainsSet) {
    if (!urlSet.value.has(d)) return false
  }
  return knownDomainsSet.size > 0
})

const allLibraryIndeterminate = computed(() => {
  let n = 0
  for (const d of knownDomainsSet) {
    if (urlSet.value.has(d)) n++
  }
  return n > 0 && n < knownDomainsSet.size
})

const allLibrarySelectedCount = computed(() => {
  let n = 0
  for (const d of knownDomainsSet) {
    if (urlSet.value.has(d)) n++
  }
  return n
})

const allLibraryTotalCount = computed(() => knownDomainsSet.size)

function categorySelectedCount (categoryId: number): number {
  return getDomainsForCategoryId(categoryId).filter((d) => urlSet.value.has(d)).length
}

function categoryTotalCount (categoryId: number): number {
  return getDomainsForCategoryId(categoryId).length
}

function emitAfter() {
  props.afterChange?.()
}

function toggleDomain(domain: string, checked: boolean) {
  const d = String(domain).trim()
  if (!d) return
  const next = [...props.libraryUrls]
  if (checked) {
    if (!next.includes(d)) next.push(d)
  } else {
    const idx = next.indexOf(d)
    if (idx !== -1) next.splice(idx, 1)
  }
  setLibraryUrls(next)
  recomputeCategoryIds()
  emitAfter()
}

function toggleCategory(categoryId: number, checked: boolean) {
  const doms = getDomainsForCategoryId(categoryId)
  if (checked) {
    const cur = new Set(props.libraryUrls.map((u) => String(u).trim()).filter(Boolean))
    for (const x of doms) cur.add(x)
    setLibraryUrls([...cur])
  } else {
    const remove = new Set(doms)
    setLibraryUrls(props.libraryUrls.filter((u) => !remove.has(String(u).trim())))
  }
  recomputeCategoryIds()
  emitAfter()
}

function onToggleAllLibrary(val: boolean | string | number) {
  const checked = val === true || val === 'true'
  if (checked) {
    const cur = new Set(props.libraryUrls.map((u) => String(u).trim()).filter(Boolean))
    knownDomainsSet.forEach((d) => cur.add(d))
    setLibraryUrls([...cur])
  } else {
    setLibraryUrls(
      props.libraryUrls.filter((u) => !knownDomainsSet.has(String(u).trim())),
    )
  }
  recomputeCategoryIds()
  emitAfter()
}

watch(
  () =>
    [props.libraryUrls.join('\u0000'), (props.extraManualDomains || []).join('\u0001')].join('\u0002'),
  () => {
    recomputeCategoryIds()
  },
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_popover, {
      visible: panelVisible.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((panelVisible).value = $event)),
      placement: "bottom-start",
      trigger: "manual",
      width: "calc(100vw - 20% - 145px)",
      disabled: _ctx.disabled,
      "show-arrow": false,
      offset: -30,
      "popper-class": popperClassNames,
      "popper-options": {
        modifiers: [
          { name: 'preventOverflow', options: { boundary: 'viewport' } },
        ],
        strategy: 'fixed',
      }
    }, {
      reference: _withCtx(() => [
        _createElementVNode("div", {
          ref_key: "referenceRef",
          ref: referenceRef,
          class: "domain-selection-field",
          onClick: openPanel
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.libraryUrls.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.libraryUrls, (d) => {
                    return (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: d,
                      content: d,
                      placement: "top",
                      "show-after": 400
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, {
                          class: "domain-tag",
                          closable: "",
                          type: "info",
                          size: "small",
                          disabled: _ctx.disabled,
                          onClose: ($event: any) => (removeLibraryDomain(d))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(titleForLibraryDomain(d)), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClose"])
                      ]),
                      _: 2
                    }, 1032, ["content"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_input, {
              ref_key: "searchInputRef",
              ref: searchInputRef,
              modelValue: searchKeyword.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
              class: "domain-selection-field__search",
              size: "small",
              placeholder: _unref(t)('accessRestriction.domainCategorySearchPlaceholder'),
              disabled: _ctx.disabled,
              onFocus: onSearchFocus,
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
              onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["prevent","stop"]), ["enter"]))
            }, null, 8, ["modelValue", "placeholder", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('accessRestriction.domainCategorySelectedDomains', { n: totalSelectedCount.value })), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('accessRestriction.domainCategoryCustomDomainHint')), 1),
              _createVNode(_component_el_button, {
                type: "text",
                size: "small",
                disabled: _ctx.disabled,
                onClick: _withModifiers(onCustomDomainClick, ["stop"]),
                style: {"font-size":"14px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('accessRestriction.domainCategoryCustomDomainBtn')) + " ", 1),
                  _createVNode(_component_el_icon, { class: "el-icon-arrow-down" })
                ]),
                _: 1
              }, 8, ["disabled"]),
              _hoisted_7,
              _createVNode(_component_el_button, {
                type: "text",
                size: "small",
                disabled: _ctx.disabled,
                onClick: _withModifiers(onBatchImportClick, ["stop"]),
                class: "domain-selection-field__batch-import",
                icon: "el-icon-upload2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('accessRestriction.domainBatchImport')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ], 512)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "domain-category-picker__panel",
          onMousedown: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
          onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: _normalizeClass(["cat-row", { 'is-active': activeCategoryId.value === 0 }]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (activeCategoryId.value = 0))
                }, [
                  _createVNode(_component_el_checkbox, {
                    "model-value": allLibrarySelected.value,
                    indeterminate: allLibraryIndeterminate.value,
                    disabled: _ctx.disabled,
                    onChange: onToggleAllLibrary,
                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, ["model-value", "indeterminate", "disabled"]),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('accessRestriction.domainCategorySelectAll')), 1),
                  _createVNode(_component_el_tag, {
                    class: "cat-count-tag",
                    size: "small",
                    type: "info",
                    effect: "plain",
                    round: "",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(allLibrarySelectedCount.value) + " / " + _toDisplayString(allLibraryTotalCount.value), 1)
                    ]),
                    _: 1
                  })
                ], 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(domainCategoryWebsiteData), (block, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: _normalizeClass(["cat-row", { 'is-active': activeCategoryId.value === idx + 1 }]),
                    onClick: ($event: any) => (activeCategoryId.value = idx + 1)
                  }, [
                    _createVNode(_component_el_checkbox, {
                      "model-value": isCategoryFull(idx + 1),
                      indeterminate: isCategoryPartial(idx + 1),
                      disabled: _ctx.disabled,
                      onChange: (v) => toggleCategory(idx + 1, v),
                      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, ["model-value", "indeterminate", "disabled", "onChange"]),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(domainCategoryLabel(block.categoryI18nKey)), 1),
                    _createVNode(_component_el_tag, {
                      class: "cat-count-tag",
                      size: "small",
                      type: "info",
                      effect: "plain",
                      round: "",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(categorySelectedCount(idx + 1)) + " / " + _toDisplayString(categoryTotalCount(idx + 1)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_el_icon, { class: "el-icon-arrow-right" })
                    ])
                  ], 10, _hoisted_12))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                (filteredRightSites.value.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(filteredRightSites.value, (site) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: site.domain,
                        class: "cat-row"
                      }, [
                        _createVNode(_component_el_checkbox, {
                          "model-value": urlSet.value.has(_unref(toLibraryWildcardDomain)(site.domain)),
                          disabled: _ctx.disabled,
                          onChange: (v) => toggleDomain(_unref(toLibraryWildcardDomain)(site.domain), !!v)
                        }, null, 8, ["model-value", "disabled", "onChange"]),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(site.title) + "(" + _toDisplayString(_unref(toLibraryWildcardDomain)(site.domain)) + ")", 1)
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(t)('common.noData')), 1))
              ])
            ])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["visible", "disabled"])
  ]))
}
}

})